var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamChatOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5980_9825",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1C9.5514 1 10 1.4486 10 2V6C10 6.5514 9.5514 7 9 7H5.82751C5.15961 7 4.53182 7.26001 4.05972 7.73221L3 8.7919V8C3 7.4478 2.5523 7 2 7C1.4486 7 1 6.5514 1 6V2C1 1.4486 1.4486 1 2 1H9ZM9 0H2C0.8954 0 0 0.8954 0 2V6C0 7.1045 0.8954 8 2 8L2.00012 9.99901C2.00012 10.3004 2.24672 10.5 2.50372 10.5C2.62662 10.5 2.75181 10.4543 2.85361 10.3525L4.76682 8.4393C5.04812 8.1579 5.42961 8 5.82751 8H9C10.1046 8 11 7.1045 11 6V2C11 0.8953 10.1046 0 9 0ZM14 5.5H12.4997C12.2236 5.5 11.9997 5.7238 11.9997 6C11.9997 6.2761 12.2236 6.5 12.4997 6.5H14C14.5523 6.5 15 6.9477 15 7.5V11.5401C15 12.0943 14.5338 12.4892 13.9797 12.5002C13.4368 12.511 12.9999 12.9545 12.9999 13.5V14.2919L11.9404 13.2323C11.4715 12.7634 10.8356 12.5 10.1725 12.5H7C6.4477 12.5 6 12.0523 6 11.5V9.9393C6 9.6632 5.7762 9.4393 5.5 9.4393C5.2239 9.4393 5 9.6632 5 9.9393V11.5C5 12.6046 5.8954 13.5 7 13.5H10.1726C10.5704 13.5 10.952 13.658 11.2332 13.9393L13.1464 15.8525C13.2483 15.9543 13.3735 16 13.4964 16C13.7534 16 13.9999 15.8004 13.9999 15.499V13.5C15.1045 13.5 16 12.6046 16 11.5V7.5C16 6.3954 15.1046 5.5 14 5.5Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5980_9825)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#131619"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamChatOutlined);
export default __webpack_public_path__ + "static/media/team-chat-outlined.9a3aadbd9ed47f9f10cba2e18c3e4dbc.svg";
export { ForwardRef as ReactComponent };